function breadcrumbRoute({ page, previousRouteObj }) {
    if (
        !page ||
        !page.slug ||
        !page.slug.en ||
        !page.slug.es ||
        (page._type === 'page' && page.slug.en.current === 'home')
    ) {
        return null
    }
    // currently only 1 level of breadcrumbs is supported
    const breadcrumb = {
        parent: {
            label: {
                en: null,
                es: null,
            },
            route: {
                en: null,
                es: null,
            },
        },
    }
    if (page._type === 'article') {
        breadcrumb.parent.route.en = '/blog/'
        breadcrumb.parent.route.es = '/es/blog/'
        breadcrumb.parent.label.en = 'Articles'
        breadcrumb.parent.label.es = 'Artículos'
    } else if (page._type === 'topic') {
        breadcrumb.parent.route.en = '/blog/'
        breadcrumb.parent.route.es = '/es/blog/'
        breadcrumb.parent.label.en = 'Blog'
        breadcrumb.parent.label.es = 'Blog'
    } else if (page._type === 'industry') {
        breadcrumb.parent.route.en = '/industries/'
        breadcrumb.parent.route.es = '/es/industrias/'
        breadcrumb.parent.label.en = 'Industries'
        breadcrumb.parent.label.es = 'Industrias'
    } else if (page._type === 'category') {
        breadcrumb.parent.route.en = '/products/'
        breadcrumb.parent.route.es = '/es/productos/'
        breadcrumb.parent.label.en = 'Products'
        breadcrumb.parent.label.es = 'Productos'
    } else if (page._type === 'account') {
        breadcrumb.parent.route.en = '/my-account/dashboard/'
        breadcrumb.parent.route.es = '/es/mi-cuenta/tablero/'
        breadcrumb.parent.label.en = 'My Account'
        breadcrumb.parent.label.es = 'Mi cuenta'
    } else if (page._type === 'whitepaper') {
        breadcrumb.parent.route.en = '/white-papers/'
        breadcrumb.parent.route.es = '/es/documentos-tecnicos/'
        breadcrumb.parent.label.en = 'White Papers'
        breadcrumb.parent.label.es = 'Documentos Técnicos'
    } else if (page._type === 'resource') {
        breadcrumb.parent.route.en = previousRouteObj?.route?.includes(
            '/products/'
        )
            ? previousRouteObj.route
            : '/resources/'
        breadcrumb.parent.route.es = previousRouteObj?.route?.includes(
            'es/productos/'
        )
            ? previousRouteObj.route
            : '/es/documentos/'

        breadcrumb.parent.label.en = previousRouteObj?.route?.includes(
            '/products/'
        )
            ? previousRouteObj.label
            : 'Resources'

        breadcrumb.parent.label.es = previousRouteObj?.route?.includes(
            'es/productos/'
        )
            ? previousRouteObj.label
            : 'Documentos'
    } else if (page._type === 'testimonial') {
        breadcrumb.parent.route.en = '/testimonials/'
        breadcrumb.parent.route.es = '/es/testimonios/'
        breadcrumb.parent.label.en = 'Testimonials'
        breadcrumb.parent.label.es = 'Testimonios'
    } else if (page._type === 'team') {
        breadcrumb.parent.route.en = '/team/'
        breadcrumb.parent.route.es = '/es/personal/'
        breadcrumb.parent.label.en = 'Team'
        breadcrumb.parent.label.es = 'El personal'
    } else if (page._type === 'product' || page._type === 'productSingle') {
        breadcrumb.parent.route.en = '/products/'
        breadcrumb.parent.route.es = '/es/productos/'
        breadcrumb.parent.label.en = 'All Products'
        breadcrumb.parent.label.es = 'Todos los productos'
    }
    // } else if (page._type !== 'page') {
    //     breadcrumb.parent.route.en = '/oops/'
    //     breadcrumb.parent.route.es = '/es/oops/'
    //     breadcrumb.parent.label.en = 'All Products'
    //     breadcrumb.parent.label.es = 'Todos los productos'
    // }
    return breadcrumb
}

export { breadcrumbRoute as default }
